import { fetchRequestWithTypes } from '../index';
import { booleanToState } from './constants';

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_ERRORED = 'GET_NOTIFICATIONS_ERRORED';

export const getNotificationsSettings = () => {
	return fetchRequestWithTypes({
		types: [
			GET_NOTIFICATIONS_REQUEST,
			GET_NOTIFICATIONS_SUCCESS,
			GET_NOTIFICATIONS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/comms/subscription-statuses`,
		},
	});
};

export const PATCH_NOTIFICATIONS_REQUEST = 'PATCH_NOTIFICATIONS_REQUEST';
export const PATCH_NOTIFICATIONS_SUCCESS = 'PATCH_NOTIFICATIONS_SUCCESS';
export const PATCH_NOTIFICATIONS_ERRORED = 'PATCH_NOTIFICATIONS_ERRORED';

export const patchNotificationsSettings = (data) => (dispatch) => {
	// Map boolean values to Braze states
	const requestBody = {};
	// Transactional SMS is Twilio-managed and not opt-outable — do not PATCH it.
	const fieldMapping = ['email', 'push', 'sms_marketing'];

	fieldMapping.forEach((field) => {
		if (data[field] !== undefined) {
			requestBody[field] = {
				state: booleanToState(data[field]),
			};
		}
	});

	const requestAction = fetchRequestWithTypes({
		types: [
			PATCH_NOTIFICATIONS_REQUEST,
			PATCH_NOTIFICATIONS_SUCCESS,
			PATCH_NOTIFICATIONS_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: `/apis/customers/v1/comms/subscription-statuses`,
			body: requestBody,
		},
	});

	return dispatch(requestAction); // Return the promise so callers can await it
};
